export default {
    baseStyle: {
        container: {
            position: 'relative',
            spacing: {base: 6, lg: '40px'},
            height: {base: '100%'},
            maxW: {base: '458px'},
        },
        centerContent: {
            margin: {base: '0 auto'},
            width: {base: '100%'}
        },
        cta: {
            width: {base: '100%'},
            minH: {base: '48px'}
        },
        addAddressCta: {
            maxW: {lg: '343px'},
            fontSize: 'md'
        },
        addressWrapper: {
            flexDirection: {base: 'column'},
            justifyContent: {base: 'space-between'},
            flex: {base: '1'}
        },
        noAddressTitle: {
            fontSize: {base: 'md'},
            lineHeight: {base: '20px'},
            fontWeight: 'bold',
            textTransform: 'uppercase',
            marginTop: {base: 8, lg: 0},
            marginBottom: {base: 2},
        },
        noAddressSubTitle: {
            fontSize: {base: 'sm'},
            lineHeight: {base: '18px'},
            marginBottom: {base: 6, lg: 10},
        }
    },
    headingAddressBook: {
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: {base: 'center', lg: 'start'},
            fontSize: {base: '20px', lg: '24px'},
            lineHeight: {base: '24px', lg: '30px'},
            fontWeight: {base: 'bold'},
            textTransform: 'uppercase',
            position: 'relative',
        },
        backButton: {
            position: 'absolute',
            left: '0',
            m: '0'
        }
    },
    formStyle: {
        container: {
            display: {base: 'flex'},
            flexDirection: {base: 'column'},
            justifyContent: {base: 'space-between'},
            flex: '1'
        },
        submitCta: {
            marginTop: {base: '40px'}
        },
        deleteCtaContainer: {
            display: {base: 'flex'},
            justifyContent: {base: 'center'},
            marginTop: {base: 8}
        },
        errorContainer: {
            marginTop: {base: 4, lg: 0},
            marginBottom: {lg: 8}
        }
    },
    addressCard: {
        container: {
            borderColor: {base: 'grey.300'},
            marginBottom: {base: 8}
        },
        wrapper: {
            position: {base: 'relative'},
            paddingRight: {base: 7}
        },
        preferred: {
            fontSize: {base: 'xs'},
            lineHeight: {base: '15px'},
            textTransform: 'uppercase',
            paddingBottom: {base: 2},
            color: 'grey.700'
        },
        title: {
            fontSize: {base: 'md'},
            lineHeight: {base: '20px'},
            textTransform: 'uppercase',
            fontWeight: 'bold',
            paddingBottom: {base: 2}
        },
        address: {
            fontSize: {base: 'sm'},
            lineHeight: {base: '18px'},
        },
        editIcon: {
            position: {base: 'absolute'},
            right: {base: 0},
            top: {base: 0},
            cursor: 'pointer'
        }
    },
    parts: []
}
